import React from "react";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Typography,
  IconButton,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import {
  Attachment,
  Refresh,
  Update,
  DeleteOutline,
  ArrowDownward,
  ArrowUpward,
} from "@material-ui/icons";
import classes from "./AdvanceCustomedTable.module.scss";
import moment from "moment";
import numeral from "numeral";
import { useHistory } from "react-router-dom";

// Components
import TextField from "StandardComponents/CustomTextfield/CustomTextField";

export default function AdvanceCustomedTable(props) {
  const history = useHistory();
  const {
    data = [],
    headers,
    status,
    handleOnChangeData,
    rowCount,
    numSelected,
    isSelected,
    type,
    requestType,
    role,
    loading = false,
    headersCheck,
    onChange,
    handleOnSelectAll,
  } = props;
  const [direction, setDirection] = React.useState(true);

  const handleOnSort = () => {
    if (direction) {
      setDirection(false);
    } else {
      setDirection(true);
    }
  };

  const handleOnView = (id, type) => {
    history.push(`/CheckRequest/${id}`);
  };

  const handleOnViewDraft = (id, type) => {
    if (type === "Cash Advance") {
      history.push(`/CashAdvance/${id}`);
    } else if (type === "Liquidation") {
      history.push(
        `/MyDashBoard/CRIS/requestor/create-request/liquidations/${id}/Draft`
      );
    } else {
      history.push(`/Draft/${id}`);
    }
  };

  const handleOnViewLiquidation = (id, type) => {
    history.push(`/Liquidation/${id}`);
  };

  return (
    <React.Fragment>
      <div
        className={classes.root}
        style={{ width: type === "drafts" ? "94%" : "100%" }}
      >
        <Table className={classes.table}>
          <TableHead className={classes["table-head"]}>
            <TableRow className={classes["table-head-row"]}>
              {type === "my_requests_checks" && status === "In Process" ? (
                <>
                  <TableCell
                    className={classes["table-head-cell"]}
                    style={{ width: "40px" }}
                  ></TableCell>
                  <TableCell
                    className={classes["table-head-cell"]}
                    style={{ width: "40px" }}
                  >
                    <Checkbox
                      style={{ color: "white" }}
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={numSelected === rowCount}
                      onChange={handleOnSelectAll}
                    />
                  </TableCell>
                  {headersCheck.map((item, index) => (
                    <TableCell
                      className={classes["table-head-cell"]}
                      style={{ width: item.width }}
                    >
                      {item.label}
                    </TableCell>
                  ))}
                </>
              ) : type === "my_requests_checks" &&
                status === "Check Preparation" ? (
                <>
                  <TableCell
                    className={classes["table-head-cell"]}
                    style={{ width: "40px" }}
                  >
                    <Checkbox
                      style={{ color: "white" }}
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={numSelected === rowCount}
                      onChange={handleOnSelectAll}
                    />
                  </TableCell>
                  {headersCheck.map((item, index) => (
                    <TableCell
                      className={classes["table-head-cell"]}
                      style={{ width: item.width }}
                    >
                      {item.label}
                    </TableCell>
                  ))}
                </>
              ) : type === "my_requests_checks" &&
                status === "Check Prepared" ? (
                <>
                  <TableCell
                    className={classes["table-head-cell"]}
                    style={{ width: "40px" }}
                  >
                    <Checkbox
                      style={{ color: "white" }}
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={numSelected === rowCount}
                      onChange={handleOnSelectAll}
                    />
                  </TableCell>
                  {headersCheck.map((item, index) => (
                    <TableCell
                      className={classes["table-head-cell"]}
                      style={{ width: item.width }}
                    >
                      {item.label}
                    </TableCell>
                  ))}
                </>
              ) : type === "my_requests_checks" &&
                status === "Check Available" ? (
                <>
                  <TableCell
                    className={classes["table-head-cell"]}
                    style={{ width: "40px" }}
                  >
                    <Checkbox
                      style={{ color: "white" }}
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={numSelected === rowCount}
                      onChange={handleOnSelectAll}
                    />
                  </TableCell>
                  {headersCheck.map((item, index) => (
                    <TableCell
                      className={classes["table-head-cell"]}
                      style={{ width: item.width }}
                    >
                      {item.label}
                    </TableCell>
                  ))}
                </>
              ) : type === "my_requests_checks" && status === "Released" ? (
                <>
                  {headersCheck.map((item, index) => (
                    <TableCell
                      className={classes["table-head-cell"]}
                      style={{ width: item.width }}
                    >
                      {item.label}
                    </TableCell>
                  ))}
                </>
              ) : type === "for_endorsement_manager" ? (
                <>
                  <TableCell
                    className={classes["table-head-cell"]}
                    style={{ width: "40px" }}
                  >
                    <Checkbox
                      style={{ color: "white" }}
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={numSelected === rowCount}
                      onChange={handleOnSelectAll}
                    />
                  </TableCell>
                  {headers.map((item, index) => (
                    <TableCell
                      className={classes["table-head-cell"]}
                      style={{ width: item.width }}
                    >
                      {item.label}
                    </TableCell>
                  ))}
                </>
              ) : (
                <>
                  {headers.map((item, index) => (
                    <TableCell className={classes["table-head-cell"]}>
                      {item.label}
                    </TableCell>
                  ))}
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody className={classes["table-body"]}>
            {type === "drafts" ? (
              <>
                {data.map((item, index) => (
                  <TableRow
                    hover
                    className={classes["table-body-row"]}
                    onClick={() => {
                      handleOnViewDraft(
                        item._id,
                        item.requestType,
                        requestType
                      );
                    }}
                  >
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestType}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.vendor ? item?.vendor : "-"}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.creationDate
                        ? moment(item.creationDate).format(
                            "MMM DD YYYY HH:MM:SS"
                          )
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "liquidation" ? (
              <>
                {data.map((item, index) => (
                  <TableRow
                    hover
                    className={classes["table-body-row"]}
                    onClick={() =>
                      item.CAStatus === "close"
                        ? handleOnView(item._id, item.requestType)
                        : handleOnViewLiquidation(item._id, item.requestType)
                    }
                  >
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.dateReleased
                        ? moment(item.dateReleased).format("MM/DD/YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.deadLineForLiquidation
                        ? moment(item.deadLineForLiquidation).format(
                            "MM/DD/YYYY"
                          )
                        : "-"}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱{numeral(item.totalNetPrice).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.project.projectName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.dateLiquidated}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.CAStatus}
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "my_requests_checks" && status === "In Process" ? (
              <>
                {data.map((item, index) => (
                  <TableRow hover className={classes["table-body-row2"]}>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip
                        title={
                          item.dateDownloaded
                            ? moment(item.dateDownloaded).format(
                                "MMMM DD, YYYY HH:MM"
                              )
                            : "File not yet downloaded"
                        }
                      >
                        <IconButton
                          className={
                            item.dateDownloaded
                              ? classes.icon_button_faded
                              : classes.icon_button
                          }
                        >
                          <Attachment
                            className={
                              item.dateDownloaded
                                ? classes.icon_faded
                                : classes.icon
                            }
                          />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Checkbox
                        inputProps={{ "aria-label": "primary checkbox" }}
                        checked={isSelected(item._id)}
                        onChange={(e) => {
                          onChange(e, item._id);
                        }}
                      />
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {index + 1}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestType}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.totalNetPrice >= 1
                        ? numeral(item.totalNetPrice).format("0,0.00")
                        : numeral(item.amount).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip title="Must be 9 characters...">
                        <TextField
                          defaultValue={""}
                          onChange={(e) =>
                            handleOnChangeData("apvNumber", index, e)
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip title="Format must be MM/DD/YYYY...">
                        <TextField
                          defaultValue={""}
                          onChange={(e) =>
                            handleOnChangeData("postingDate", index, e)
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.dueDate
                        ? moment(item.dueDate).format("MM/DD/YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.dueDate
                        ? moment(item.dataCreated).format("MM/DD/YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.vendor.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.releasingCenter}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.department.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestor.firstName + " " + item.requestor.lastName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Link to={`/MyDashBoard/CRIS/check-request/${item._id}`}>
                        View
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "my_requests_checks" &&
              status === "Check Preparation" ? (
              <>
                {data.map((item, index) => (
                  <TableRow hover className={classes["table-body-row2"]}>
                    <TableCell className={classes["table-body-cell"]}>
                      <Checkbox
                        inputProps={{ "aria-label": "primary checkbox" }}
                        checked={isSelected(item._id)}
                        onChange={(e) => {
                          onChange(e, item._id);
                        }}
                      />
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestType}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.totalNetPrice >= 1
                        ? numeral(item.totalNetPrice).format("0,0.00")
                        : numeral(item.amount).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip title="Must be 9 characters...">
                        <TextField
                          defaultValue={""}
                          onChange={(e) =>
                            handleOnChangeData("cvNumber", e, index)
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip title="Format must be MM/DD/YYYY...">
                        <TextField
                          defaultValue={""}
                          onChange={(e) =>
                            handleOnChangeData("cvDate", e, index)
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.apvNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.postingDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dueDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dateCreated).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.vendor.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.releasingCenter}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.department.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestor.firstName + " " + item.requestor.lastName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Link to={`/MyDashBoard/CRIS/check-request/${item._id}`}>
                        View
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "my_requests_checks" && status === "Check Prepared" ? (
              <>
                {data.map((item, index) => (
                  <TableRow hover className={classes["table-body-row2"]}>
                    <TableCell className={classes["table-body-cell"]}>
                      <Checkbox
                        inputProps={{ "aria-label": "primary checkbox" }}
                        checked={isSelected(item._id)}
                        onChange={(e) => {
                          onChange(e, item._id);
                        }}
                      />
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestType}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.totalNetPrice >= 1
                        ? numeral(item.totalNetPrice).format("0,0.00")
                        : numeral(item.amount).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip title="Must be 9 characters...">
                        <TextField
                          defaultValue={""}
                          onChange={(e) =>
                            handleOnChangeData("paymentRef", e, index)
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip title="Format must be MM/DD/YYYY...">
                        <TextField
                          defaultValue={""}
                          onChange={(e) =>
                            handleOnChangeData("checkAvailableDate", e, index)
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip title="Format must be MM/DD/YYYY...">
                        <TextField
                          defaultValue={""}
                          onChange={(e) =>
                            handleOnChangeData("checkDate", e, index)
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.cvNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.cvDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dueDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dateCreated).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.vendor.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.releasingCenter}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.department.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestor.firstName + " " + item.requestor.lastName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Link to={`/MyDashBoard/CRIS/check-request/${item._id}`}>
                        View
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "my_requests_checks" &&
              status === "Check Available" ? (
              <>
                {data.map((item, index) => (
                  <TableRow hover className={classes["table-body-row2"]}>
                    <TableCell className={classes["table-body-cell"]}>
                      <Checkbox
                        inputProps={{ "aria-label": "primary checkbox" }}
                        checked={isSelected(item._id)}
                        onChange={(e) => {
                          onChange(e, item._id);
                        }}
                      />
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestType}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.totalNetPrice >= 1
                        ? numeral(item.totalNetPrice).format("0,0.00")
                        : numeral(item.amount).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Tooltip title="Format must be MM/DD/YYYY...">
                        <TextField
                          defaultValue={""}
                          onChange={(e) =>
                            handleOnChangeData("dateReleased", e, index)
                          }
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.checkNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.checkAvailableDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.checkDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dueDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dateCreated).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.vendor.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.releasingCenter}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.department.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestor.firstName + " " + item.requestor.lastName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Link to={`/MyDashBoard/CRIS/check-request/${item._id}`}>
                        View
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "my_requests_checks" && status === "Released" ? (
              <>
                {data.map((item, index) => (
                  <TableRow
                    hover
                    className={classes["table-body-row"]}
                    onClick={() => {
                      handleOnView(item._id, item.requestType);
                    }}
                  >
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestType}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.vendor.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.totalNetPrice >= 1
                        ? numeral(item.totalNetPrice).format("0,0.00")
                        : numeral(item.amount).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.checkAvailableDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dateReleased).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.department.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.project.projectName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.requestor.firstName + " " + item.requestor.lastName}
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "for_endorsement" ? (
              <>
                {data.map((item, index) => (
                  <TableRow
                    hover
                    className={classes["table-body-row"]}
                    onClick={() => {
                      handleOnView(item._id, item.requestType);
                    }}
                  >
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.dateCreated).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.expectedCompletionDate).format(
                        "MM/DD/YYYY"
                      )}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.dueDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.vendor?.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.totalNetPrice >= 1
                        ? numeral(item.totalNetPrice).format("0,0.00")
                        : numeral(item.amount).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.project?.projectName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.department?.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.requestor?.firstName +
                        " " +
                        item.requestor.lastName}
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "all_request" ? (
              <>
                {data.map((item, index) => (
                  <TableRow
                    hover
                    className={classes["table-body-row"]}
                    onClick={() => {
                      handleOnView(item._id, item.requestType);
                    }}
                  >
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.vendor?.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.project?.projectName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.department?.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.dateCreated).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.expectedCompletionDate).format(
                        "MM/DD/YYYY"
                      )}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.dueDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.totalNetPrice >= 1
                        ? numeral(item.totalNetPrice).format("0,0.00")
                        : numeral(item.amount).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.status}
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "for_endorsement_manager" ? (
              <>
                {data.map((item, index) => (
                  <TableRow hover className={classes["table-body-row2"]}>
                    <TableCell className={classes["table-body-cell"]}>
                      <Checkbox
                        inputProps={{ "aria-label": "primary checkbox" }}
                        checked={isSelected(item._id)}
                        onChange={(e) => {
                          onChange(e, item._id);
                        }}
                      />
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.vendor?.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.project?.projectName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.department?.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.dateCreated).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.expectedCompletionDate).format(
                        "MM/DD/YYYY"
                      )}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item?.dueDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.totalNetPrice >= 1
                        ? numeral(item.totalNetPrice).format("0,0.00")
                        : numeral(item.amount).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item?.status}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      <Link to={`/MyDashBoard/CRIS/check-request/${item._id}`}>
                        View
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : type === "department_head" ? (
              <>
                {data.map((item, index) => (
                  <TableRow
                    hover
                    className={classes["table-body-row"]}
                    onClick={() => {
                      handleOnView(item._id, item.requestType);
                    }}
                  >
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.creationDate).format("MMM DD YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.expectedCompletionDate
                        ? moment(item.expectedCompletionDate).format(
                            "MMM DD YYYY"
                          )
                        : "-"}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dueDate).format("MMM DD YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.vendor.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.amount >= 1
                        ? numeral(item.amount).format("0,0.00")
                        : numeral(item.totalNetPrice).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.project.projectName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.status}
                    </TableCell>
                  </TableRow>
                ))}
              </>
            ) : (
              <>
                {data.map((item, index) => (
                  <TableRow
                    hover
                    className={classes["table-body-row"]}
                    onClick={() => {
                      handleOnView(item._id, item.requestType);
                    }}
                  >
                    <TableCell className={classes["table-body-cell"]}>
                      {item.crfNo}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.creationDate).format("MMM DD YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.expectedCompletionDate
                        ? moment(item.expectedCompletionDate).format(
                            "MMM DD YYYY"
                          )
                        : "-"}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {moment(item.dueDate).format("MMM DD YYYY")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.vendor.bpName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      ₱
                      {item.amount >= 1
                        ? numeral(item.amount).format("0,0.00")
                        : numeral(item.totalNetPrice).format("0,0.00")}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.department.centerName}
                    </TableCell>
                    <TableCell className={classes["table-body-cell"]}>
                      {item.status}
                    </TableCell>
                  </TableRow>
                ))}
              </>
            )}
          </TableBody>
        </Table>
        {loading ? (
          <div className={classes.loading}>
            <CircularProgress className={classes.circular} thickness={10} />
            <Typography className={classes.label}>Loading....</Typography>
          </div>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
}
